/* @flow */

import {withStyles} from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

const StyledTableCellTextMobileComponent = withStyles(_ => ({
  root: {
    padding: '4px 2px 4px 2px'
  },
  head: {
    lineHeight: '1.5'
  },
  paddingCheckbox: {
    padding: 0,
    width: 'auto'
  },
  paddingNone: {
    padding: '0 2px',
    width: 'auto'
  },
  paddingLarger: {
    padding: '0 2px'
  },
  body: {
    fontSize: '0.8125rem',
  },

}))(TableCell);

export default StyledTableCellTextMobileComponent;
